import { render, staticRenderFns } from "./crudReport.vue?vue&type=template&id=04b06c52&scoped=true&"
import script from "./crudReport.vue?vue&type=script&lang=js&"
export * from "./crudReport.vue?vue&type=script&lang=js&"
import style0 from "./crudReport.vue?vue&type=style&index=0&id=04b06c52&prod&lang=css&"
import style1 from "./crudReport.vue?vue&type=style&index=1&id=04b06c52&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04b06c52",
  null
  
)

export default component.exports